'use client';

import { useCallback } from 'react';
import { BackButton } from './components/buttons/BackButton';
import { useProgressRouter } from './hooks/useTopProgress';

type Props = {
  showBackButton?: boolean;
  title?: string;
  renderRight?: React.ReactNode;
  onClickBackButton?: () => void;
  headerClassName?: string;
  containerClassName?: string;
  backUrl?: string;
};
export const Header = ({ showBackButton = true, title, renderRight, onClickBackButton, headerClassName, containerClassName = 'max-w-[400px]', backUrl }: Props) => {
  const router = useProgressRouter();
  const handleClickBackButton = useCallback(() => {
    if (onClickBackButton) {
      onClickBackButton();
      return;
    }
    const handleBack = () => {
      const targetBackUrl = backUrl;

      if (targetBackUrl) {
        router.push(targetBackUrl);
        return;
      }

      // document.referrerで前のページがあるかチェック
      if (document.referrer && document.referrer !== window.location.href) {
        router.back();
      } else {
        router.push('/mypage');
      }
    };
    handleBack();
  }, [onClickBackButton, router, backUrl]);

  return (
    <header className={'h-[56px]'}>
      <div className={`fixed left-0 right-0 z-10 mx-auto ${containerClassName}`} style={{ top: 'var(--web-payment-error-banner-height, 0px)' }}>
        <div className={`h-[56px] px-3 flex items-center justify-between bg-white border-b-[0.5px] ${headerClassName}`}>
          <div>
            {showBackButton && (
              <div style={{ marginBottom: -4 }}>
                <BackButton size={20} onClick={handleClickBackButton} />
              </div>
            )}
          </div>
          {title && <h1 className="text-base font-semibold">{title}</h1>}
          <div>{renderRight && renderRight}</div>
        </div>
      </div>
    </header>
  );
};
